import { Term } from 'components/works/api';
import { useTerms } from 'components/works/context';
import { IconType } from 'lib/FL';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { Icons } from './Icon';
import styles from './Option.module.scss';

export type Option = {
  image: string;
  title: string;
  icons: IconType[];
  description: string;
  price: number;
  isLowestPrice: boolean;
  terms: string[];
  perPriceText: string;
  demoUrl: string;
};

export const OptionItem: FC<{ option: Option; }> = (props) => {
  const { option } = props;

  const p = option.price.toLocaleString();

  const terms = useTerms();
  const optionTerms = option.terms.map((slug) => terms.option.find((e) => e.slug === slug)).filter(Boolean) as Term[];

  const params = new URLSearchParams();
  params.set('page', '1');
  optionTerms.forEach((term) => {
    params.append('option', term.id.toString());
  });

  return (
    <li className={styles.item}>
      <div className={styles.itemImage}>
        <img src={option.image} alt='' />
      </div>
      <div className={styles.itemText}>
        <h2 className={styles.itemTitle}>{option.title}</h2>
        <Icons icons={option.icons} />
        <p className={styles.itemDescription}>{option.description}</p>
        {option.terms && option.terms.length > 0 && (
          <Link to={`/works/?${params.toString()}`} className={styles.itemExample}>
            制作事例はこちら
          </Link>
        )}
        {option.demoUrl && (
          <a href={option.demoUrl} target="_blank" rel='noreferrer' className={styles.itemExample}>
            デモ画面はこちら
          </a>
        )}
        <p className={styles.itemPrice}>
          {option.perPriceText && <span className={styles.itemPriceUnit}>{option.perPriceText}</span>}
          <span className={styles.itemPriceValue}>{p}</span>
          <span className={styles.itemPriceUnit}>円</span>
          {option.isLowestPrice && <span className={styles.itemPriceUnit}>～</span>}
        </p>
      </div>
    </li>
  );
};

export const OptionList: FC<{ options: Option[] }> = (props) => {
  const { options } = props;
  return (
    <ul className={styles.list}>
      {options.map((option) => (
        <OptionItem key={option.title} option={option} />
      ))}
    </ul>
  );
};
